import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AuthStore, BookingSubscription } from '@store';
import { SubscriptionStatus } from '@vi-iot/client';

@Component({
  selector: 'app-commercial-status-tile',
  templateUrl: './commercial-status-tile.component.html',
  styleUrls: ['./commercial-status-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialStatusTileComponent implements OnChanges {
  @Input() subscription: BookingSubscription;
  @Input() isActiveSubscription: boolean;
  @Input() isAnyActiveOrCancelledSubscription: boolean;

  readonly subscriptionStatus = SubscriptionStatus;
  dateLabel: string;

  constructor(public authStore: AuthStore) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.subscription.currentValue?.status !== changes.subscription.previousValue?.status) {
      this.dateLabel = this.getDateLabel();
    }
  }

  private getDateLabel(): string {
    switch (this.subscription.status?.toLowerCase()) {
      case SubscriptionStatus.active:
        return '+BOOKING.OVERVIEW.FLATRATE.AUTOMATIC_EXTENSION';

      case SubscriptionStatus.canceled:
        return '+BOOKING.OVERVIEW.SUBSCRIPTION.EXPIRES_ON';

      case SubscriptionStatus.expired:
        return '+BOOKING.OVERVIEW.FLATRATE.EXPIRED_ON';
    }
  }
}
